import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompletedModalFormComponent } from '../_pop-ups/completed-modal-form/completed-modal-form.component';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeliveryType, TemplateModalAction } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InputModalFormComponent } from 'src/app/forms-modal/_inputs/input-form/input-modal-form.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

@Component({
  selector: 'app-template-notification-modal-form',
  templateUrl: './template-notification-modal-form.component.html',
  styleUrls: ['./template-notification-modal-form.component.scss']
})
export class TemplateNotificationModalFormComponent {
  public formTitle = 'PWA Template';

  @Input() embeddedFormMode: boolean | undefined;
  
  @Output() notificationTemplateModalFormClosed: EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}> = new EventEmitter<{TemplateModalAction : TemplateModalAction,TemplateId : number}>();
  
  @ViewChild('completedModalForm',    { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('inputModalForm',        { static: false }) inputModalForm!    : InputModalFormComponent;
  @ViewChild('templateModalForm',     { static: false }) templateModalForm! : TemplateRef<void>;
  
  get canEditTemplate() { return this.authenticationService.canEditSystemOwned(this.template?.systemOwned ?? false); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false);      }

  private curUser                     : SystemUserDTO;
  private selectedTemplateReplacement!: CommunicationTemplateReplacements;
  private sureSimCompanyId            : number | undefined;
  private templateModalFormRef!       : NgbModalRef;

  public alreadyEnabled               : boolean = false;
  public companyDefaults!             : CommunicationTemplatesDefaultsDTO;
  public hideMessageType              : boolean = false;
  public hideSaveAndEnable            : boolean = false;
  public inviewUserIdData!            : IdAndDescriptionDTO[];
  public lastMouseEvent               : MouseEvent | undefined;
  public lastSystemValueTarget        : HTMLInputElement | HTMLTextAreaElement | undefined;
  public messageType                  : string = '';
  public saveAllocation               : boolean = false;
  public selectedTemplateReplacementId: number = 0;
  public template!                    : CommunicationTemplateDTO;
  public templateFormSubmitted        : boolean = false;
  public templateForm!                : UntypedFormGroup;
  public templateModalAction          : TemplateModalAction = TemplateModalAction.Cancel;
  public templateReplacements         : CommunicationTemplateReplacements[] = [];
  public templateReplacementsValues   : {name:string, id:number}[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private commConfigService    : CommConfigService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private formBuilder          : UntypedFormBuilder,
    private modalService         : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnDestroy() {
    this.closeForm(this.templateModalAction);
  }

  public closeForm(templateModalAction: TemplateModalAction): void {
    try {
      this.notificationTemplateModalFormClosed.emit({TemplateModalAction:templateModalAction, TemplateId:this.template?.id ?? -1});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formData() {
    return this.templateForm.controls;
  }

  public openForm(messageType: string, template: CommunicationTemplateDTO, companyId: number, templateReplacements: CommunicationTemplateReplacements[], companyDefaults: CommunicationTemplatesDefaultsDTO, 
                  alreadyEnabled: boolean, saveAllocation: boolean = true, hideMessageType: boolean = false, hideSaveAndEnable: boolean = false): void {
    try {
      this.alreadyEnabled             = alreadyEnabled;
      this.companyDefaults            = companyDefaults;
      this.hideMessageType            = hideMessageType;
      this.hideSaveAndEnable          = hideSaveAndEnable;
      this.messageType                = messageType;
      this.saveAllocation             = saveAllocation;
      this.sureSimCompanyId           = companyId;
      this.template                   = template;
      this.templateFormSubmitted      = false;
      this.templateModalAction        = TemplateModalAction.Cancel;
      this.templateReplacements       = templateReplacements;
      this.templateReplacementsValues = this.templateReplacements.map(item => ({  name: item.columnName ?? "", id: item.id }))
      this.openModal();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private reflectChanges(): void {
    try{
      this.template.name = this.formData['templateName'].value;        
      this.template.subject = this.formData['subject'].value;
      this.template.body = this.formData['notification'].value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.templateForm);
      this.templateForm = this.formBuilder.group({ });
      this.addFormFields(this.templateForm);

      this.populateFormFields();
      //this.templateForm.valueChanges.subscribe(changedValues => this.reflectChanges());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields() {
    try {
      if (this.templateForm != undefined) {
        this.templateForm.controls["templateName"].setValue(this.template.name);
        this.templateForm.controls["subject"].setValue(this.template.subject);
        this.templateForm.controls["notification"].setValue(this.template.body);
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      this.addFormControl(formGroup, "templateName", this.template.name      ,   [Validators.required]);
      this.addFormControl(formGroup, "subject",      this.template.subject   ,   [Validators.required]);
      this.addFormControl(formGroup, "notification", this.template.body      ,   [Validators.required]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form: UntypedFormGroup, dataField: string, value: boolean | number | string, validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.templateModalFormRef = this.modalService.open(this.templateModalForm, 
        { 
          backdrop: this.modalBackGround, 
          centered: true,
          keyboard: false,
          size    : msSize.Large 
        });
    }
    catch(e) {
      this.notificationTemplateModalFormClosed.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public saveAndEnable() {
    try {
      this.reflectChanges();
      let saveBody = {
        AlertTypeId          : this.template.alertTypeId,
        ID                   : this.template.id,
        CompanyId            : this.sureSimCompanyId,
        DeliveryTypeId       : DeliveryType.Notification,
        MessageTypeId        : this.template.messageTypeId,
        Name                 : this.template.name,
        Subject              : this.template.subject,
        Body                 : this.template.body,
        CC                   : this.template.cc,
        BCC                  : this.template.bcc,
        FromEmail            : this.template.fromEmail,
        FromNumber           : this.template.fromNumber,
        UseDefaultCC         : this.template.useDefaultCC,
        UseDefaultBCC        : this.template.useDefaultBCC,
        UseDefaultFromEmail  : this.template.useDefaultFromEmail,
        UseDefaultFromNumber : this.template.useDefaultFromNumber,
        EnteredBy            : this.curUser.userId,
        Active               : true,
        Deleted              : false,
        SystemOwned          : false
      };
      let enableBody = {
        TemplateId      : this.template.id,
        CompanyId       : this.sureSimCompanyId,
        DeliveryTypeId  : DeliveryType.Notification,
        MessageTypeId   : this.template.messageTypeId,
        EnteredBy       : this.curUser.userId
      };
      if(this.template.id > 0){
        this.commConfigService.editCommunicationTemplate(saveBody).subscribe(id => {
          if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations", "Template has been updated and enabled.");
            });
          } else {
            this.templateModalAction = TemplateModalAction.SaveAndEnable;
            this.completedModalForm.openForm("Congratulations", "Template has been updated and enabled.");
          }
        });
      }
      else{
        this.commConfigService.createCommunicationTemplate(saveBody).subscribe(id => {
          enableBody.TemplateId = id;
          this.template.id      = id;
          if (this.saveAllocation) {
            this.commConfigService.enableCompanyTemplate(enableBody).subscribe(y => {
              this.templateModalAction = TemplateModalAction.SaveAndEnable;
              this.completedModalForm.openForm("Congratulations", "Template has been created and enabled.");
            });
          } else {
            this.templateModalAction = TemplateModalAction.SaveAndEnable;
            this.completedModalForm.openForm("Congratulations", "Template has been created and enabled.");
          }
        })
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public save() {
    try {
        this.reflectChanges();
        let saveBody = {
          AlertTypeId          : this.template.alertTypeId,
          ID                   : this.template.id,
          CompanyId            : this.sureSimCompanyId,
          DeliveryTypeId       : DeliveryType.Notification,
          MessageTypeId        : this.template.messageTypeId,
          Name                 : this.template.name,
          Subject              : this.template.subject,
          Body                 : this.template.body,
          CC                   : this.template.cc,
          BCC                  : this.template.bcc,
          FromEmail            : this.template.fromEmail,
          FromNumber           : this.template.fromNumber,
          UseDefaultCC         : this.template.useDefaultCC,
          UseDefaultBCC        : this.template.useDefaultBCC,
          UseDefaultFromEmail  : this.template.useDefaultFromEmail,
          UseDefaultFromNumber : this.template.useDefaultFromNumber,
          EnteredBy            : this.curUser.userId,
          Active               : true,
          Deleted              : false,
          SystemOwned          : false
        };
        if(this.template.id > 0){
          this.commConfigService.editCommunicationTemplate(saveBody).subscribe(x => {
            this.templateModalAction = TemplateModalAction.Save;
            this.completedModalForm.openForm("Congratulations", "Template has been updated.");
          });
        }
        else{
          this.commConfigService.createCommunicationTemplate(saveBody).subscribe(id => {
            this.template.id         = id;
            this.templateModalAction = TemplateModalAction.Save;
            this.completedModalForm.openForm("Congratulations", "Template has been created.");
          });
        }
        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    this.closeForm(this.templateModalAction);
    this.templateModalFormRef.close('Close click');
  }

  invalidInputs(): boolean {
    let valid = (this.formData['templateName'].value != null && this.formData['templateName'].value.trim() != '' 
            && this.formData['subject'].value != null && this.formData['subject'].value.trim() != '' && this.formData['notification'].value != null && this.formData['notification'].value.trim() != ''
          );

    if (valid) {
      valid = this.getDodgySystemPlaceHolders(this.formData['notification'].value) == "";
    }
    return !valid;
  }

  public getDodgySystemPlaceHolders(inputValue:string): string {
    let words: string[] = [];
    let dodgyPlaceHolders: string = "";

    if (inputValue != null) {
      words = inputValue
        .trim()
        .replace(/\,/," ")
        .replace(/@@/g," @@")
        .split(/\s+/); // Splits by one or more spaces
  
      words.forEach(word => {
        if(word.startsWith('@@')) {
          if(!this.templateReplacements.some(p => word.startsWith(p.placeHolder ?? ""))) {
            dodgyPlaceHolders += ',' + word;
          }
        }
      });
  
      if (dodgyPlaceHolders != "") {
        dodgyPlaceHolders = dodgyPlaceHolders.substring(1,10000);
      }
    }

    return dodgyPlaceHolders;
  }

  public saveAsNew() {
    try {
      this.reflectChanges();
      this.commConfigService.createCommunicationTemplate({
        AlertTypeId          : this.template.alertTypeId,
        ID                   : 0,
        CompanyId            : this.sureSimCompanyId,
        DeliveryTypeId       : DeliveryType.Notification,
        MessageTypeId        : this.template.messageTypeId,
        Name                 : this.template.name,
        Subject              : this.template.subject,
        Body                 : this.template.body,
        CC                   : this.template.cc,
        BCC                  : this.template.bcc,
        FromEmail            : this.template.fromEmail,
        FromNumber           : this.template.fromNumber,
        UseDefaultCC         : this.template.useDefaultCC,
        UseDefaultBCC        : this.template.useDefaultBCC,
        UseDefaultFromEmail  : this.template.useDefaultFromEmail,
        UseDefaultFromNumber : this.template.useDefaultFromNumber,
        EnteredBy            : this.curUser.userId,
        Active               : true,
        Deleted              : false,
        SystemOwned          : false
      }).subscribe(id => {
        this.template.id         = id;
        this.templateModalAction = TemplateModalAction.Save;
        this.completedModalForm.openForm("Congratulations", "Template has been saved.");
    });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  // addToSubject() {
  //   let selectedSystemValue = this.templateReplacements.find(x => x.id == this.selectedTemplateReplacementId);
  //   if(selectedSystemValue){
  //     if(this.formData['subject'].value != null && this.formData['subject'].value.trim() != ''){
  //       this.formData['subject'].setValue(this.formData['subject'].value + selectedSystemValue.placeHolder);
  //     }
  //     else{
  //       this.formData['subject'].setValue(selectedSystemValue.placeHolder);
  //     }
  //   }
  // }

  // addToMessage() {
  //   let selectedSystemValue = this.templateReplacements.find(x => x.id == this.selectedTemplateReplacementId);
  //   if(selectedSystemValue){
  //     if(this.formData['notification'].value != null && this.formData['notification'].value.trim() != ''){
  //       this.formData['notification'].setValue(this.formData['notification'].value + selectedSystemValue.placeHolder);
  //     }
  //     else{
  //       this.formData['notification'].setValue(selectedSystemValue.placeHolder);
  //     }
  //   }
  // }

  public inputModalFormSubmitted(inputValue: string) {
    try {
      let selectedSystemValue = this.templateReplacements.find(x => x.id == Number(inputValue));
      if(selectedSystemValue){
        this.insertTextAtCursor(<HTMLTextAreaElement>this.lastSystemValueTarget, selectedSystemValue.placeHolder ?? "");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleMouseClick(event: MouseEvent): void {
    try {
      if (event.ctrlKey) {
        this.lastMouseEvent       =event;
        this.lastSystemValueTarget=<HTMLInputElement | HTMLTextAreaElement>event.target;
        this.inputModalForm.openForm();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleKeyUp(event: KeyboardEvent): void {
    try {
      const target=<HTMLInputElement | HTMLTextAreaElement>event.target;

      if (!target || (target.tagName != 'INPUT' && target.tagName != 'TEXTAREA'))
        return;

      const caret=target.selectionStart ?? 0;

      if (caret<2 || target.value.substring(caret-2, caret) != '@@')
        return;

      const before=target.value.substring(0, caret-2);
      const after =target.value.substring(caret);

      target.value=before+after;
      target.setSelectionRange(caret-2, caret-2);
      target.dispatchEvent(new Event('input'));

      this.lastMouseEvent        = undefined;
      this.lastSystemValueTarget = target;
      this.inputModalForm.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public insertTextAtCursor(textArea: HTMLTextAreaElement, text: string): void {
    const start = textArea.selectionStart;
    const end = textArea.selectionEnd;
  
    // Insert the text at the cursor position
    const before = textArea.value.substring(0, start);
    const after = textArea.value.substring(end);
    textArea.value = before + text + after;
  
    // Move the cursor to the end of the inserted text
    const cursorPosition = start + text.length;
    textArea.setSelectionRange(cursorPosition, cursorPosition);
  
    // Trigger change detection if needed
    textArea.dispatchEvent(new Event('input'));
  }
}
